<template>
<div class="flex">
   <h3 class="text-white text-2xl font-bold uppercase mb-3">User information</h3>
    <span v-if="$page.props.flash.message" class="ml-5 mt-2 text-green-700">{{ $page.props.flash.message }}</span>
    <span v-for="error in getErrors('user_information')"
    class="ml-5 mt-2 text-red-600">{{ error }}</span>
</div>

    <div class="flex">
        <div class="w-3/4">

            <div class="grid grid-cols-2 gap-3 border-b border-gray-800 pr-2">
                <div>
                    <label for="first_name">First name</label>
                    <input type="text" class="input-black" id="first_name"
                    v-model="form.first_name">
                </div>
                <div>
                    <label for="last_name">Last name</label>
                    <input type="text" class="input-black" id="last_name"
                    v-model="form.last_name">
                </div>
                <div class="col-span-full">
                    <label for="email">Email Address</label>
                    <input disabled type="email" class="input-black opacity-40" id="email"
                    v-model="form.email">
                </div>
                <div>
                    <label for="password">Password</label>
                    <input type="password" class="input-black" id="password"
                    v-model="form.password">
                </div>
                <div>
                    <label for="password_confirmation">Confirm Password</label>
                    <input type="password" class="input-black" id="password_confirmation"
                    v-model="form.password_confirmation">
                </div>
            </div>
        </div>
        <div class="w-1/4 px-6 border-l border-b border-gray-800">
        </div>

    </div>

    <div class="flex justify-center">
        <button v-if="!form.processing" @click="updateUsersData" class="btn btn-gradient mt-2 mb-2">
            <i class="save mr-2"></i>Save
        </button>
        <button v-else class="btn btn-gradient mt-2 mb-2"><Spinner/></button>
    </div>

</template>


<script>
import { getErrors } from '@/Pages/GlobalHelpers';
import Spinner from '@/UI/Spinner'

export default {
    components:{
        Spinner
    },
    props: {
        user: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                first_name: null,
                last_name: null,
                email: null,
                password: null,
                password_confirmation: null,
            }),
            uploadBoxState: null,
        }
    },
    mounted(){
        this.form.first_name = this.user.first_name;
        this.form.last_name = this.user.last_name;
        this.form.email = this.user.email;
    },
    methods: {
        updateUsersData() {
            this.form.post(route('update-my-area'));
        },
        getErrors:getErrors,
    }
}
</script>
